interface CrateMarkProps {
  className?: string
  /** Light corner dots read better on dark backgrounds (e.g. footer) */
  light?: boolean
}

/**
 * CrateWeb logo mark — the 3D blue crate from Brand-Assets/logo-horizontal.svg,
 * rebuilt as primitives so it stays crisp at any size.
 */
const CrateMark = ({ className, light = false }: CrateMarkProps) => {
  const id = light ? 'cm-l' : 'cm-d'
  return (
    <svg viewBox="0 0 64 64" className={className} fill="none" aria-hidden="true">
      <defs>
        <linearGradient id={`${id}-primary`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#2563eb" />
          <stop offset="1" stopColor="#1e40af" />
        </linearGradient>
        <linearGradient id={`${id}-secondary`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#3b82f6" />
          <stop offset="1" stopColor="#60a5fa" />
        </linearGradient>
      </defs>
      {/* back face */}
      <path d="M22 8 52 8 52 32 22 32Z" fill="#1e3a8a" opacity="0.3" />
      {/* left face */}
      <path d="M6 20 22 8 22 32 6 44Z" fill={`url(#${id}-primary)`} />
      {/* right face */}
      <path d="M38 20 52 8 52 32 38 44Z" fill={`url(#${id}-secondary)`} />
      {/* top face */}
      <path d="M6 20 22 8 52 8 38 20Z" fill="#60a5fa" />
      {/* front face (open box) */}
      <path d="M6 20 38 20 38 44 6 44Z" fill="#2563eb" />
      {/* code/web detail lines */}
      <line x1="13" y1="28" x2="30" y2="28" stroke="#fff" strokeWidth="2" opacity="0.6" />
      <line x1="13" y1="34" x2="25" y2="34" stroke="#fff" strokeWidth="2" opacity="0.4" />
      {/* corner accents */}
      <circle cx="9" cy="25" r="2" fill={light ? '#bfdbfe' : '#93c5fd'} />
      <circle cx="35" cy="25" r="2" fill={light ? '#bfdbfe' : '#93c5fd'} />
    </svg>
  )
}

export default CrateMark
